export const statusOrder = status => {
    if( status === 'CANCEL' ){
        status = '-3'
    }else if( status === 'COMPLETE' ){
        status = '1'
    }else{
        status = status
    }

    switch ( String(status) ) {
        case '1':
            return { status: `Success` , color: `success`}
        case '0':
            return { status: `Waiting` , color: `warning`} 
        case '-1':
            return { status: `Fail` , color: `danger`} 
        case '-2':
            return { status: `Pending` , color: `info`} 
        case '-3':
            return { status: `Cancel` , color: `danger`} 
        default:
            return { status: `-` , color: `dark`}
    }
};